import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Páginas para escritorio
import HomeScreen from "./pages/HomeScreen";
import FleetPage from "./pages/FleetPage";
import NewFAQPage from "./pages/NewFAQPage";  // Se importa el nuevo archivo
import ContactPage from "./pages/ContactPage";
import InfoPage from "./pages/InfoPage"; // Ajuste para la ruta de Booking
import ReservationScreen from "./pages/ReservationScreen";

// Componentes exclusivos para móviles
import MobileHome from "./mobile/MobileHome";  
import MobileExclusiveFleet from "./mobile/MobileExclusiveFleet";
import MobileReserveRide from "./mobile/MobileReserveRide";
import MobileExclusiveFAQ from "./mobile/MobileExclusiveFAQ";
import MobileVIPAssistance from "./mobile/MobileVIPAssistance";

// Componentes comunes
import Header from "./components/Header"; 
import Footer from "./components/Footer";

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <Router>
      <div className={`container ${isMobile ? "mobile-container" : ""}`}>
        {/* Solo se renderiza el Header una vez */}
        <Header />

        <Routes>
          {isMobile ? (
            <>
              <Route path="/" element={<MobileHome />} />
              <Route path="/fleet" element={<MobileExclusiveFleet />} />
              <Route path="/reservations" element={<MobileReserveRide />} />
              <Route path="/faq" element={<MobileExclusiveFAQ />} />
              <Route path="/contact" element={<MobileVIPAssistance />} />
            </>
          ) : (
            <>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/fleet" element={<FleetPage />} />
              <Route path="/reservations" element={<ReservationScreen />} />
              {/* Se utiliza el nuevo componente para FAQs */}
              <Route path="/faq" element={<NewFAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/info" element={<InfoPage />} /> {/* Ajustado */}
            </>
          )}
        </Routes>

        {/* Se muestra el Footer en todas las páginas */}
        <Footer isMobile={isMobile} />
      </div>
    </Router>
  );
}

export default App;